import OrientationModal from './OrientationModal'

export default OrientationModal
